// VER-218: in-memory step-up token cache (Step 11.1).
// A successful re-OTP mints a step-up token that unlocks sensitive actions for
// ~5 min on the backend. We cache it in memory so an admin making a burst of
// changes (e.g. editing several users) is prompted once, not per-click.
// In-memory only — never persisted — same XSS reasoning as the access token.
let token = null;
let expiresAt = 0;

// Held a touch under the server's 5-min TTL so we never hand back a token that's
// about to be rejected mid-request.
const TTL_MS = 4 * 60 * 1000;

export function getStepUpToken() {
  if (token && Date.now() < expiresAt) return token;
  token = null;
  return null;
}

export function setStepUpToken(t) {
  token = t;
  expiresAt = Date.now() + TTL_MS;
}

export function clearStepUpToken() {
  token = null;
  expiresAt = 0;
}
